import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { TextInput } from './FormElements';

// http://localhost:8000/rest/v1/zombie/user-submissions/?brand=el&approved=true&task_id=ad&phone=7655&user=admin

const SubSearch = withFormik({
  validationSchema: Yup.object().shape({
    brand: Yup.string(),
    retailer: Yup.string(),
    task_id: Yup.string(),
    phone: Yup.string(),
    country: Yup.string(),
  }),
  mapPropsToValues: ({ data }) => ({
    brand: data.brand,
    retailer: data.approved,
    task_id: data.task_id,
    phone: data.phone,
    country: data.country,
  }),
  handleSubmit: async (payload, { props, setSubmitting, setErrors }) => {
    try {
      const errors = await props.handleSubmit(payload);
      setSubmitting(false);
      if (errors) {
        setErrors(errors);
      }
    } catch (e) {
      throw e;
    }
  },
  displayName: 'SearchForm',
});

const subSearchForm = (props) => {
  const {
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    values,
  } = props;

  return (
    <form onSubmit={handleSubmit} className='login-form'>
      <Row>
        <Col>
          <TextInput
            id='phone'
            type='text'
            label='Phone'
            placeholder='Phone contains'
            value={values.phone}
            error={touched.phone && errors.phone}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>
        <Col>
          <TextInput
            id='task_id'
            type='text'
            label='Task ID'
            placeholder='Task ID equals'
            value={values.task_id}
            error={touched.task_id && errors.task_id}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>
        <Col>
          <TextInput
            id='brand'
            type='text'
            label='Brand'
            placeholder='Brand starts with'
            value={values.brand}
            error={touched.brand && errors.brand}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>

        <Col>
          <TextInput
            id='retailer'
            type='text'
            label='Retailer'
            placeholder='Retailer starts with'
            value={values.retailer}
            error={touched.retailer && errors.retailer}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>

        <Col>
          <TextInput
            id='country'
            type='text'
            label='Country'
            placeholder='Country starts with'
            value={values.country}
            error={touched.country && errors.country}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>

        <Col>
          <Button
            style={{ height: '40px', marginTop: '30px' }}
            type='submit'
            color='primary'
            disabled={!props.isValid || isSubmitting}
          >
            Filter
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export const SubmissionsSearchForm = SubSearch(subSearchForm);
